import { render, staticRenderFns } from "./PayServiceInfo.vue?vue&type=template&id=bdb5aeda&scoped=true&"
import script from "./PayServiceInfo.vue?vue&type=script&lang=ts&"
export * from "./PayServiceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PayServiceInfo.vue?vue&type=style&index=0&id=bdb5aeda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb5aeda",
  null
  
)

export default component.exports